import React, { lazy, Suspense } from 'react';
import {render} from 'react-dom';

/* utilities */
import { parseDatasetToProps } from "../../parseDatasetToProps";

const SmartContentOverview = lazy(() => import(/* webpackChunkName: "SmartContentOverview" */ './components/SmartContentOverview'));

const smartContentOverviewNodes = Array.from(document.querySelectorAll('.smart-content-overview'));

// Check nodes
if (smartContentOverviewNodes) {
    smartContentOverviewNodes.forEach((node) => {
        // Parse props
        const props = parseDatasetToProps(node.dataset);

        // Render component
        render(
            <Suspense fallback={<></>}>
                <SmartContentOverview
                    {...props}
                />
            </Suspense>,
            node
        );
    });
}